import React from "react";

/**
 * HostHelp brand logo as inline SVG.
 * Props:
 *   - size: "xs" | "sm" | "md" | "lg" | "xl" (controls height)
 *   - variant: "dark" | "light" (text color for different backgrounds)
 *   - iconOnly: boolean (show only the icon, no text)
 */
export const HostHelpLogo = ({ size = "md", variant = "dark", iconOnly = false, className = "" }) => {
  const sizes = { xs: 22, sm: 28, md: 34, lg: 42, xl: 52 };
  const h = sizes[size] || sizes.md;
  const iconSize = h;
  const textColor = variant === "light" ? "#FFFFFF" : "#1a1a18";
  const accentColor = "#FF9500";

  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="hosthelp-logo">
      {/* Icon: Orange rounded rect with trending-up graph */}
      <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="40" height="40" rx="10" fill={accentColor} />
        <path
          d="M10 28L16 22L20 25L26 17L30 12"
          stroke="white"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M24 12H30V18"
          stroke="white"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {/* Text: HOST + Help */}
      {!iconOnly && (
        <svg height={h * 0.55} viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="HostHelp">
          <text x="0" y="19" fontFamily="'Poppins','DM Sans',sans-serif" fontWeight="700" fontSize="22" letterSpacing="-0.5">
            <tspan fill={textColor}>HOST</tspan>
            <tspan fill={accentColor}>Help</tspan>
          </text>
        </svg>
      )}
    </span>
  );
};

/**
 * Standalone icon for favicon/small usage
 */
export const HostHelpIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="40" height="40" rx="10" fill="#FF9500" />
    <path
      d="M10 28L16 22L20 25L26 17L30 12"
      stroke="white"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M24 12H30V18"
      stroke="white"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

/**
 * Returns raw SVG string for canvas/print rendering (QR cards etc.)
 */
export const getHostHelpLogoSvgString = (variant = "dark") => {
  const textColor = variant === "light" ? "#FFFFFF" : "#1a1a18";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="56" viewBox="0 0 300 56" fill="none">
    <rect width="56" height="56" rx="14" fill="#FF9500"/>
    <path d="M14 40L22 32L28 36L36 24L42 17" stroke="white" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M34 17H42V25" stroke="white" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <text x="68" y="39" font-family="Plus Jakarta Sans,DM Sans,sans-serif" font-weight="700" font-size="34" letter-spacing="-0.5">
      <tspan fill="${textColor}">HOST</tspan><tspan fill="#FF9500">Help</tspan>
    </text>
  </svg>`;
};
